import classNames from 'classnames'

import type { SupportedLanguage } from '../i18n/i18n.no-deps'
import { noSearchResults } from './helpers/noSearchResults'
import { css, html, LitElement } from 'lit'
import { property, customElement } from 'lit/decorators.js'

@customElement('zaptic-string-list')
export class StringList extends LitElement {
    static styles = css`
        :host {
            height: 0;
            overflow: visible;
        }

        .above {
            transform: translate(0, -100%);
        }

        .string-list {
            position: relative;
            margin: 0;
            padding: 0;
            max-height: calc(40px * 5);
            overflow-y: scroll;
        }

        .list-item {
            display: flex;
            align-items: center;
            font-weight: var(--font-weight-medium);
            font-size: 14px;
            padding: 10px 15px;
            border-radius: 5px;
            cursor: pointer;
        }
        .item-focus {
            background: var(--disabled);
        }
        .item-circle {
            margin-right: 6px;
        }

        .not-found {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 25px 45px;
        }
        .not-found-text {
            padding-bottom: 15px;
            color: #b2c3db;
            font-weight: var(--font-weight-medium);
            font-size: 14px;
        }
    `

    public scrollSelectedIntoView() {
        const selected = this.shadowRoot.querySelector('.item-focus') as HTMLElement
        selected.scrollIntoView({ block: 'nearest' })
    }

    @property({
        attribute: 'selected',
        converter: (val) => JSON.parse(val),
    })
    selectedIndex: number

    @property({
        attribute: 'items',
        converter: (val) => JSON.parse(val),
    })
    myItems: string[]

    @property({
        attribute: 'language',
        converter: (val) => JSON.parse(val),
    })
    myLanguage: SupportedLanguage

    private handleHover(index: number) {
        return () => {
            const event = new CustomEvent('onHovered', { detail: index })
            this.dispatchEvent(event)
        }
    }

    private handleClick(index: number) {
        return () => {
            const event = new CustomEvent('onSelected', { detail: index })
            this.dispatchEvent(event)
        }
    }

    private itemHtml(item: any, index: number, selected: boolean) {
        return html`
            <li
                class=${classNames('list-item', { 'item-focus': selected })}
                @mouseover=${this.handleHover(index)}
                @focus=${this.handleHover(index)}
                @click=${this.handleClick(index)}
                tabindex="-1"
            >
                ${item.name}
            </li>
        `
    }

    private itemListHtml(items: string[], selectedIndex: number) {
        return html`
            <ul class="string-list">
                ${items.map((item, idx) => this.itemHtml(item, idx, selectedIndex === idx))}
            </ul>
        `
    }

    render() {
        if (this.myItems == null || this.myLanguage == null || this.selectedIndex == null) return

        const inner =
            this.myItems.length === 0
                ? noSearchResults(this.myLanguage)
                : this.itemListHtml(this.myItems, this.selectedIndex)

        return html` ${inner} `
    }
}
